<script lang="ts">
  import { UsersTexts } from './UsersTexts';
  import { onMount } from 'svelte';
  import { LayerHandler } from '../../handlers/LayerHandler';
  import Headline from '../../components/content/Headline.svelte';
  import Content from '../../components/content/Content.svelte';
  import ErrorMessages from '../../components/boxes/ErrorMessages.svelte';
  import FormButton from '../../components/forms/FormButton.svelte';
  import FormButtonLine from '../../components/forms/FormButtonLine.svelte';
  import { ApiService } from '../../api/services/ApiService';
  import { PageService } from '../../services/PageService.svelte';
  import { UserService } from '../../services/UserService.svelte';

  /**
   * The page Microsoft sends the browser back to (`/microsoft?code=…&state=…` or `?error=…`) — shown with and without
   * login (LyMain). Hands the answer to the API once: a link goes on to "Mein Konto", a login to the home page.
   */
  const Layer = new LayerHandler();
  const MyLayer = Layer.getContentLayer();

  let IsLoading = $state(true);
  let Errors = $state<string[]>([]);

  onMount(() => {
    void complete();
  });

  async function complete(): Promise<void> {
    const State = PageService.getParam('state') ?? '';
    const Code = PageService.getParam('code') ?? '';
    const Failure = PageService.getParam('error') ?? '';

    // - code and state must not stay in the address bar or the history
    window.history.replaceState({}, '', PageService.getPath('microsoft'));
    const Result = await ApiService.users.completeMicrosoft({ state: State, ...(Code !== '' ? { code: Code } : {}), ...(Failure !== '' ? { error: Failure } : {}) });
    IsLoading = false;
    if (!Result.isOk || Result.body === undefined) {
      Errors = ApiService.listErrorTexts(Result);
      await UserService.refresh();
      return;
    }

    // -
    await UserService.refresh();
    if (Result.body.purpose === 'link') {
      PageService.replace(`${PageService.getPath('user')}?microsoft=linked`);
      return;
    }
    PageService.replace('/');
  }

  function goOn(): void {
    PageService.replace(UserService.body.isLoggedIn ? PageService.getPath('user') : '/');
  }
</script>

<section class="contentLayer contentLayer{MyLayer} contentLayerChildAbs">
  <Headline state="brand">{UsersTexts.MicrosoftAccount}</Headline>

  {#if IsLoading}
    <Content>
      <p>{UsersTexts.MicrosoftChecking}</p>
    </Content>
  {:else if Errors.length > 0}
    <ErrorMessages errors={Errors} />

    <FormButtonLine>
      <FormButton state="gray" onclick={goOn}>{UserService.body.isLoggedIn ? UsersTexts.ToAccount : UsersTexts.ToLogin}</FormButton>
    </FormButtonLine>
  {/if}
</section>
